export const monthNames = [
  { label: "มกราคม", value: 1 },
  { label: "กุมภาพันธ์", value: 2 },
  { label: "มีนาคม", value: 3 },
  { label: "เมษายน", value: 4 },
  { label: "พฤษภาคม", value: 5 },
  { label: "มิถุนายน", value: 6 },
  { label: "กรกฎาคม", value: 7 },
  { label: "สิงหาคม", value: 8 },
  { label: "กันยายน", value: 9 },
  { label: "ตุลาคม", value: 10 },
  { label: "พฤษจิกายน", value: 11 },
  { label: "ธันวาคม", value: 12 },
]

export const yearList = [
  { label: "2567", value: 2024 },
  { label: "2566", value: 2023 },
  { label: "2565", value: 2022 },
  { label: "2564", value: 2021 },
  { label: "2563", value: 2020 },
]


// WEBPACK FOOTER //
// ./src/utils/dateHelper.js